import * as betgalaxy from './RaceRunnerPropButton.styles.betgalaxy';
import * as betprofessor from './RaceRunnerPropButton.styles.betprofessor';
import * as betroyale from './RaceRunnerPropButton.styles.betroyale';
import * as fiestabet from './RaceRunnerPropButton.styles.fiestabet';
import * as goldenrush from './RaceRunnerPropButton.styles.goldenrush';
import * as juicybet from './RaceRunnerPropButton.styles.juicybet';
import * as puntcity from './RaceRunnerPropButton.styles.puntcity';
import * as puntgenie from './RaceRunnerPropButton.styles.puntgenie';
import * as questbet from './RaceRunnerPropButton.styles.questbet';
import * as sterlingparker from './RaceRunnerPropButton.styles.sterlingparker';
import * as vikingbet from './RaceRunnerPropButton.styles.vikingbet';
import * as volcanobet from './RaceRunnerPropButton.styles.volcanobet';
import * as wellbet from './RaceRunnerPropButton.styles.wellbet';
import * as forsport from './RaceRunnerPropButton.styles.forsport';
import * as junglebet from './RaceRunnerPropButton.styles.junglebet';
import * as sugarcastle from './RaceRunnerPropButton.styles.sugarcastle';
import * as oldgill from './RaceRunnerPropButton.styles.oldgill';
import * as buffalobet from './RaceRunnerPropButton.styles.buffalobet';
import * as titanbet from './RaceRunnerPropButton.styles.titanbet';
import * as slambet from './RaceRunnerPropButton.styles.slambet';
import * as gigabet from './RaceRunnerPropButton.styles.gigabet';
import * as betstride from './RaceRunnerPropButton.styles.betstride';
import * as templebet from './RaceRunnerPropButton.styles.templebet';
import * as goldenbet888 from './RaceRunnerPropButton.styles.goldenbet888';
import * as hyperbet from './RaceRunnerPropButton.styles.hyperbet';
import * as bet777 from './RaceRunnerPropButton.styles.bet777';
import * as chromabet from './RaceRunnerPropButton.styles.chromabet';
import * as bet575 from './RaceRunnerPropButton.styles.bet575';
import * as epicodds from './RaceRunnerPropButton.styles.epicodds';
import * as pyramidbet from './RaceRunnerPropButton.styles.pyramidbet';
import * as magnumbet from './RaceRunnerPropButton.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  forsport,
  junglebet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
